import CollageDesigner from './CollageDesigner';

export default CollageDesigner;
